export const iconFontAwesomeMapsKey = (
	<i className="fa-solid fa-key"></i>
);
